'use strict';

const cronParser = require('cron-parser');

angular.module('magtac')
    .service('timerFormatService', ['cronService',
        function (cronService) {
            this.availableValues = [];
            function cronToReadable(cronExpr) {
                try {
                    console.log('Parsing cron expression:', cronExpr);
                    const interval = cronParser.parseExpression(cronExpr);
                    const fields = interval.fields;

                    const minute = fields.minute;
                    const hour = fields.hour;
                    const dom = fields.dayOfMonth;
                    const month = fields.month;
                    const dow = [...new Set(fields.dayOfWeek.map(d => (d === 7 ? 0 : d)))];
                    const year = fields.year;

                    // Minutely
                    if (hour.length === 24 && minute.length < 60 && minute.length !== 1 && dom.length === 31 && dow.length === 7 && month.length === 12) {
                        return `Every ${minute.length === 1 ? minute[0] : minute[1] - minute[0]} minute(s)`;
                    }

                    // Hourly
                    if (hour.length <= 24 && hour.length !== 1 && minute.length === 1 && dom.length === 31 && dow.length === 7 && month.length === 12) {
                        return `Every ${hour[1] - hour[0]} hour(s) at ${pad(minute[0])} past the hour`;
                    }

                    // Daily
                    if (dom.length <= 31 && dom.length !== 1 && dow.length === 7 && month.length === 12) {
                        return `Every ${dom[1] - dom[0]} day(s) at ${pad(hour[0])}:${pad(minute[0])}`;
                    }

                    // Weekly
                    if (dow.length === 1 && dom.length === 31 && month.length === 12) {
                        const days = dow.map(d => weekday(d)).join(', ');
                        return `Every ${days} at ${pad(hour[0])}:${pad(minute[0])}`;
                    }

                    // Monthly
                    if (month.length <= 12 && month.length !== 1 && dom.length < 31) {
                        return `Every ${month[1] - month[0]} month(s) on day ${dom[0]} at ${pad(hour[0])}:${pad(minute[0])}`;
                    }

                    // Yearly
                    if (month.length === 1 && dom.length === 1) {
                        const monthName = monthToString(month[0]);
                        return `Every year on ${monthName} ${dom[0]} at ${pad(hour[0])}:${pad(minute[0])}`;
                    }

                    return 'Unrecognized cron format';
                } catch (err) {
                    console.error('Error parsing cron expression', err);
                    return 'Invalid cron expression';
                }
            }

            function pad(n) {
                return n.toString().padStart(2, '0');
            }

            function weekday(n) {
                return ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'][n];
            }

            function monthToString(n) {
                return ['January', 'February', 'March', 'April', 'May', 'June',
                    'July', 'August', 'September', 'October', 'November', 'December'][n - 1];
            }



            this.formatTime = function (cron, timezone, checkForCron) {
                if (!cron) {
                    return cron;
                }

                var label = (_.find(this.availableValues, { cron: cron }) || {}).label;
                var readableCron = cronToReadable(cronService.convertCronToServerTime(cron, timezone));

                if (checkForCron) {
                    if (label) {
                        return { string: label, isCron: false };
                    } else {
                        return { string: readableCron, isCron: true };
                    }
                }

                return label || readableCron;
            }

            this.fillValues = function () {

                this.availableValues.push({
                    cron: '0 * * * * ?',
                    label: 'Every minute',
                });

                for (var i = 1; i <= 59; i++) {
                    this.availableValues.push({
                        cron: '0 0/' + i + ' * * * ?',
                        label: 'Every ' + i + ' minute' + ((i > 1) ? 's' : ''),
                    });
                }

                for (var i = 1; i <= 23; i++) {
                    this.availableValues.push({
                        cron: '0 0 0/' + i + ' * * ?',
                        label: 'Every ' + i + ' hour' + ((i > 1) ? 's' : ''),
                    });
                }

                for (var i = 1; i <= 7; i++) {
                    this.availableValues.push({
                        cron: '0 0 0 */' + i + ' * ?',
                        label: 'Every ' + i + ' day' + ((i > 1) ? 's' : ''),
                    });
                }
            }

            this.getValues = function () {
                return this.availableValues;
            }


            this.fillValues();
        }
    ]);
